// Working-day-aware day counter for leave requests.
// Mirror of server/utils/leaveDayCount.js — same algorithm, same defaults,
// so the number rendered in the UI matches the number the server deducts.
//
// Pre-2026 the dashboard pages each had their own hardcoded weekend skip
// (`dayOfWeek !== 0 && dayOfWeek !== 6`) which ignored team.workingDays —
// fine for Mon-Fri teams but wrong for Mon-Sat teams who lost their
// Saturday from the count.

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const DEFAULT_WORKING_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

function normaliseWorkingDays(input) {
  if (!Array.isArray(input) || input.length === 0) return DEFAULT_WORKING_DAYS;
  const cleaned = input
    .map(d => typeof d === 'string' ? d.trim() : '')
    .map(d => d.charAt(0).toUpperCase() + d.slice(1).toLowerCase())
    .filter(d => DAY_NAMES.includes(d));
  return cleaned.length ? cleaned : DEFAULT_WORKING_DAYS;
}

export function countWorkingDays({ startDate, endDate, workingDays, halfDay }) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (isNaN(start.getTime()) || isNaN(end.getTime()) || end < start) return 0;

  const days = normaliseWorkingDays(workingDays);
  let count = 0;
  const cursor = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());

  while (cursor <= endDay) {
    if (days.includes(DAY_NAMES[cursor.getDay()])) count++;
    cursor.setDate(cursor.getDate() + 1);
  }

  if (halfDay && count > 0) count -= 0.5;
  return count;
}
